import { Box, FormControl, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { ObservabilityToolAuthenticationTypeToggle } from 'components/status-checks/form/authentication/ObservabilityToolAuthenticationTypeToggle'
import { ObservabilityToolHeaders } from 'components/status-checks/form/authentication/ObservabilityToolHeaders'
import { ObservabilityToolPrivateNetworkIntegration } from 'components/status-checks/form/authentication/ObservabilityToolPrivateNetworkIntegration'
import { type StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'
import { useObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'
import { PRIVATE_NETWORK_INTEGRATION_OBSERVABILITY_TOOLS } from 'utils/third-party'

export const ObservabilityToolOtherAuthenticationDetails: React.FC = () => {
  const { control } = useFormContext<StatusCheckFormValues>()
  const { isEdit } = useObservabilityToolAuthenticationContext()

  const [isPrivateNetworkIntegration, observabilityToolType] = useWatch({
    control,
    name: ['isPrivateNetworkIntegration', 'observabilityTool.type']
  })

  const shouldShowPrivateNetworkIntegrationOption = observabilityToolType
    ? PRIVATE_NETWORK_INTEGRATION_OBSERVABILITY_TOOLS.has(observabilityToolType)
    : false

  return (
    <>
      <FormControl>
        {/* Using the Controller wrapper here because this value will be dynamically updated as other form values are selected */}
        <Controller
          control={control}
          name="apiBaseUrl"
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              data-testid="observability-tool-authentication-api-base-url-input"
              disabled={isEdit}
              error={Boolean(error)}
              helperText={error?.message}
              label="API Base URL"
              variant="outlined"
            />
          )}
        />
      </FormControl>
      {shouldShowPrivateNetworkIntegrationOption && (
        <Box sx={{ mt: 2 }}>
          <ObservabilityToolPrivateNetworkIntegration />
        </Box>
      )}
      <Stack spacing={2} sx={{ mt: 4 }}>
        <Typography variant="h6">Authentication</Typography>
        {isPrivateNetworkIntegration ? (
          <>
            <Typography>
              Which method would you like to authenticate your observability
              tool with?
            </Typography>
            <ObservabilityToolAuthenticationTypeToggle />
          </>
        ) : (
          <>
            <Typography>
              What value should Gremlin use for the Authorization header of this
              observability tool?
            </Typography>
            <ObservabilityToolHeaders />
          </>
        )}
      </Stack>
    </>
  )
}
